import moment from "moment";
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Tab, Tabs } from "react-bootstrap";
import { toast } from "react-toastify";
import XLSX from "xlsx";
import { getUser } from "../../../services/authService";
import {
  createAggregateMonthlyPlan,
  getMaxAggregateContainerCount,
  uploadAggregateDailyPlan,
} from "../../../services/aggregateDataService";
import { aggregateDataFiter, jdCalenderFilter } from "../../../utils/dataFilter";
import { aggregateMonthlySheetValidator } from "../../../utils/validator";
import { getJDCalendarDatesOfMonth } from "../../../services/dataService";
import { htmlEmailSend, uploadDailyPlanEmailRecepients,CC_uploadDailyPlanEmailRecepients } from "../../../services/emailService";
import { getPlanUplaodEmailBodyForAggregate } from "../../../email-template/planUploadMail";
import { getAggregateDailyContainerPlanning } from "../../../services/aggregateDataService";
import { dispatcher } from "../../../store/storeHelpers";
import * as actionTypes from "../../../store/ActionTypes"
import { aggregateDataCreatorForStore } from "../../../utils/dataFilter";

function UploadAggregatePlan({ show, handleClose, setNoDataState, setCountData, date, setDate }) {
  const [key, setKey] = useState("daily");
  const [planDate, setPlanDate] = useState(date);
  const [excelData, setExcelData] = useState("");
  const [jdMonth, setJdMonth] = useState(moment().format("YYYY-MM"));
  const [jdMonthDates, setJdMonthDates] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [isDailyFileSelected, setIsDailyFileSelected] = useState(false);
  const [disableUpload, setDisableUpload] = useState(false)

  const handleButtonState = () => {
    if (loading === true) return true
    if (loading === false && isFileSelected === false) {
      return true;
    } else return false;
  };

  const handleDailyButtonState = () => {
    if (loading === true) return true
    if (loading === false && isDailyFileSelected === false) {
      return true;
    } else return false;
  };

  useEffect(() => {
    let mounted = true;
    async function getDates() {
      try {
        setJdMonthDates([]);
        const resp = await getJDCalendarDatesOfMonth(
          moment(jdMonth).format("MMM-YYYY")
        );
        if (mounted) {
          setJdMonthDates(jdCalenderFilter(resp.data));
        }
      } catch (error) {
        setJdMonthDates([]);
      }
    }
    getDates();
    return () => (mounted = false);
  }, [jdMonth]);

  const readInputFile = (e, period) => {
      setDisableUpload(false)
      if (e.target.files.length !== 0) {
      var files = e.target.files,
        f = files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        let readedData = XLSX.read(data, { type: "binary" });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        const dataParse = XLSX.utils.sheet_to_json(ws);
        dataParse.forEach((item,index,array)=>{
          if(/[a-z]/.test(array[index].Country)) {
             array[index].Country = array[index].Country.toUpperCase();
          }
         })
        if (period === "daily") {
          setIsDailyFileSelected(true);
          if(Object.keys(dataParse[0])[0] !== "Part Number"){
            setDisableUpload(true)
            toast.error("Excel column heading should be 'Part Number'")
          }
          if(Object.keys(dataParse[0])[1] !== "Category"){
            setDisableUpload(true)
            toast.error("Excel column heading should be 'Category'")
          }
          if(Object.keys(dataParse[0])[2] !== "Country"){
            setDisableUpload(true)
            toast.error("Excel column heading should be 'Country'")
          }
          if(Object.keys(dataParse[0])[3] !== "Sub Category"){
            setDisableUpload(true)
            toast.error("Excel column heading should be 'Sub Category'")
          }
          if(Object.keys(dataParse[0])[4] !== "Quantity"){
            setDisableUpload(true)
            toast.error("Excel column heading should be 'Quantity'")
          }
          if(Object.keys(dataParse[0])[5] !== "Container"){
            setDisableUpload(true)
            toast.error("Excel column heading should be 'Container'")
          }
          if(Object.keys(dataParse[0])[6] !== "Container Type"){
            setDisableUpload(true)
            toast.error("Excel column heading should be 'Container Type'")
          }
          if(Object.keys(dataParse[0])[7] !== "Remark"){
            setDisableUpload(true)
            toast.error("Excel column heading should be 'Remark'")
          }
          // handleClose();
        } else if (period === "monthly") {
          setIsFileSelected(true);
        }
        setExcelData(dataParse);
      };
      reader.readAsBinaryString(f);
    } else {
      if (period === "daily") return setIsDailyFileSelected(false);
      if (period === "monthly") return setIsFileSelected(false);
    }
  };

  const handleSubmit = async () => {
    let counterLabel = []
		let counterValue = {
			Booked: 0,
			Pending: 0,
			Approved: 0,
			Cancelled: 0,
			Not_Booked: 0,
		}
    setLoading(true);
    const containerCountResponse = await getMaxAggregateContainerCount(planDate)
    const dataReport = aggregateDataFiter(excelData, planDate, containerCountResponse.data[0].ContainerId)
    if (dataReport.is_valid === true) {
      try {
        await uploadAggregateDailyPlan(dataReport.filteredData);
        await htmlEmailSend(uploadDailyPlanEmailRecepients,CC_uploadDailyPlanEmailRecepients, "Aggregate daily plan uploaded", getPlanUplaodEmailBodyForAggregate("Aggregate", planDate, excelData));
        if(date === moment(dataReport.filteredData[0]["Date"]).format("YYYY-MM-DD")){
					const response = await getAggregateDailyContainerPlanning(
						moment(date).format("YYYY-MM-DD")
					);
          dispatcher(
            actionTypes.AGGREGATE_BOOKING_LOADED,
            aggregateDataCreatorForStore(response.data.Resultset1)
          );
					for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
					}
					setCountData({label : counterLabel, counterData : counterValue})

        }
        setDate(moment(dataReport.filteredData[0]["Date"]).format("YYYY-MM-DD"))
        setNoDataState(false);
        setLoading(false);
        handleClose();
        toast.success("Daily plan uploaded successfully");
      } catch (error) {
        if(error.response.data.Message==="Record Not Found"){
          toast.success("Daily plan uploaded successfully");
          window.location.reload();
        }
        else{
          setLoading(false);
          toast.error("If there is any special character in file...please remove it.");
        }
   
      }
    }
    else toast.error("Some columns are missing")
  };

  const getVal = (key, dataList) => {
    if (dataList[key]) {
      return Math.round(parseFloat(dataList[key]));
    } else return 0;
  };

  const handleMonthlyDataSubmit = async () => {
    if (aggregateMonthlySheetValidator(excelData, jdMonthDates)) {
      const newData = excelData.map((item) => {
        if (item["Country"] !== "Grand Total") {
          var obj = {
            Country: item["Country"],
            ContainerType: item["Container type"],
            PlanningMonth: moment(jdMonth).format("MMM-YY"),
            TotalContainerInMonth: `${Math.round(
              parseFloat(item["Total cntr"])
            )}`,
            Created_By: getUser().uid,
          };
          for (let i = 0; i < jdMonthDates.length; i++) {
            obj[`D${i + 1}`] = `${getVal(jdMonthDates[i], item)}`;
          }
          return obj;
        }
        return null;
      });

      try {
        setLoading(true);
        await createAggregateMonthlyPlan(newData);
        setLoading(false);
        handleClose();
        toast.success("Monthly plan uploaded successfully");
      } catch (error) {
        setLoading(false);
        toast.warning("Unexpected file format");
      }
    } else toast.error("Selected file is wrong or from another month");
  };

  return (
    <>
      <Modal show={show} backdrop="static" onHide={handleClose} centered>
        <Modal.Body>
          <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
            <Tab eventKey="daily" title="Daily">
              <h4>Upload daily schedule</h4>
              <Form.Group>
                <Form.Control
                  type="date"
                  className="hiden-inp modal-date-picker-custon"
                  value={planDate}
                  defaultValue={date}
                  onChange={(e) => setPlanDate(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="file"
                  className="file-modal-input"
                  onChange={(e) => readInputFile(e, "daily")}
                />
              </Form.Group>
              <Button
                className="fr btn-sm"
                onClick={handleSubmit}
                disabled={handleDailyButtonState() || disableUpload}
              >
                {loading ? "Uploading" : "Upload"}
              </Button>
              <Button
                className="fr mr-1 btn-sm"
                variant="outline-primary"
                onClick={() => {
                  handleClose();
                  setExcelData();
                  setIsDailyFileSelected(false);
                }}
              >
                Cancel
              </Button>
            </Tab>
            <Tab eventKey="monthly" title="Monthly">
              <h4>Upload monthly plan</h4>
              <Form.Group>
                <Form.Control
                  type="month"
                  className="hiden-inp modal-month-picker-custon"
                  value={jdMonth}
                  onChange={(e) => setJdMonth(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="file"
                  className="file-modal-input"
                  onChange={(e) => readInputFile(e, "monthly")}
                />
              </Form.Group>
              <Button
                className="fr btn-sm"
                onClick={handleMonthlyDataSubmit}
                disabled={handleButtonState()}
              >
                {loading ? "Uploading" : "Upload"}
              </Button>
              <Button
                className="fr mr-1 btn-sm"
                variant="outline-primary"
                onClick={() => {
                  handleClose();
                  setExcelData();
                  setIsFileSelected(false);
                }}
              >
                Cancel
              </Button>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UploadAggregatePlan;
